<template>
  <div class="d-flex align-center ga-3 task-actions">
    <div class="show cursor-pointer">
      <svg
        @click="$router.push({ name: 'ShowTask', params: { id: item.id } })"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="hoverd"
      >
        <path
          d="M0.666504 8.00008C0.666504 8.00008 3.33317 2.66675 7.99984 2.66675C12.6665 2.66675 15.3332 8.00008 15.3332 8.00008C15.3332 8.00008 12.6665 13.3334 7.99984 13.3334C3.33317 13.3334 0.666504 8.00008 0.666504 8.00008Z"
          stroke="#666666"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.99984 10.0001C9.10441 10.0001 9.99984 9.10465 9.99984 8.00008C9.99984 6.89551 9.10441 6.00008 7.99984 6.00008C6.89527 6.00008 5.99984 6.89551 5.99984 8.00008C5.99984 9.10465 6.89527 10.0001 7.99984 10.0001Z"
          stroke="#666666"
          stroke-width="1.2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <div class="edit cursor-pointer">
      <svg
        @click="openDialog(item.id)"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="hoverd"
      >
        <g clip-path="url(#clip0_2868_26728)">
          <path
            d="M11.3335 2.00004C11.5086 1.82494 11.7165 1.68605 11.9452 1.59129C12.174 1.49653 12.4192 1.44775 12.6668 1.44775C12.9145 1.44775 13.1596 1.49653 13.3884 1.59129C13.6172 1.68605 13.8251 1.82494 14.0002 2.00004C14.1753 2.17513 14.3142 2.383 14.4089 2.61178C14.5037 2.84055 14.5524 3.08575 14.5524 3.33337C14.5524 3.58099 14.5037 3.82619 14.4089 4.05497C14.3142 4.28374 14.1753 4.49161 14.0002 4.66671L5.00016 13.6667L1.3335 14.6667L2.3335 11L11.3335 2.00004Z"
            stroke="#666666"
            stroke-width="1.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_2868_26728">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
    <div class="delete cursor-pointer">
      <svg
        @click="deleteDialog = true"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_3103_67684)">
          <path
            d="M14.9508 2.105H11.2758V1.61775C11.2753 1.18883 11.1047 0.777618 10.8014 0.474334C10.4981 0.17105 10.0868 0.000463179 9.65792 0H6.34167C5.91277 0.000487988 5.50157 0.171086 5.19829 0.474367C4.89501 0.777648 4.72441 1.18885 4.72392 1.61775V2.105H1.04883C0.924508 2.105 0.805279 2.15439 0.717372 2.24229C0.629464 2.3302 0.580078 2.44943 0.580078 2.57375C0.580078 2.69807 0.629464 2.8173 0.717372 2.90521C0.805279 2.99311 0.924508 3.0425 1.04883 3.0425H1.71064V13.1488C1.71146 13.9047 2.0121 14.6294 2.5466 15.1639C3.0811 15.6985 3.80581 15.9991 4.56173 16H11.4379C12.1938 15.9991 12.9185 15.6985 13.453 15.164C13.9875 14.6295 14.2881 13.9048 14.289 13.1489V3.0425H14.9508C15.0751 3.0425 15.1943 2.99311 15.2822 2.90521C15.3701 2.8173 15.4195 2.69807 15.4195 2.57375C15.4195 2.44943 15.3701 2.3302 15.2822 2.24229C15.1943 2.15439 15.0751 2.105 14.9508 2.105ZM5.66142 1.61775C5.66163 1.4374 5.73336 1.2645 5.86089 1.13697C5.98842 1.00944 6.16132 0.937707 6.34167 0.9375H9.65792C9.83827 0.937707 10.0112 1.00944 10.1387 1.13697C10.2662 1.2645 10.338 1.4374 10.3382 1.61775V2.105H5.66142V1.61775ZM13.3515 13.149C13.3509 13.6563 13.1491 14.1427 12.7903 14.5014C12.4316 14.8601 11.9452 15.0619 11.4379 15.0625H4.56173C4.05439 15.0619 3.56799 14.8601 3.20925 14.5014C2.8505 14.1426 2.64871 13.6562 2.64814 13.1489V3.0425H13.3515V13.149ZM7.53105 12.3355V5.03716C7.53105 4.91284 7.58043 4.79361 7.66834 4.7057C7.75625 4.61779 7.87548 4.56841 7.9998 4.56841C8.12412 4.56841 8.24335 4.61779 8.33125 4.7057C8.41916 4.79361 8.46855 4.91284 8.46855 5.03716V12.3355C8.46855 12.4598 8.41916 12.579 8.33125 12.6669C8.24335 12.7548 8.12412 12.8042 7.9998 12.8042C7.87548 12.8042 7.75625 12.7548 7.66834 12.6669C7.58043 12.579 7.53105 12.4598 7.53105 12.3355ZM10.7563 11.5268V5.84578C10.7563 5.72146 10.8057 5.60223 10.8936 5.51433C10.9815 5.42642 11.1008 5.37703 11.2251 5.37703C11.3494 5.37703 11.4686 5.42642 11.5565 5.51433C11.6444 5.60223 11.6938 5.72146 11.6938 5.84578V11.5268C11.6938 11.6511 11.6444 11.7704 11.5565 11.8583C11.4686 11.9462 11.3494 11.9956 11.2251 11.9956C11.1008 11.9956 10.9815 11.9462 10.8936 11.8583C10.8057 11.7704 10.7563 11.6511 10.7563 11.5268ZM4.30577 11.5268V5.84578C4.30577 5.72146 4.35515 5.60223 4.44306 5.51433C4.53097 5.42642 4.6502 5.37703 4.77452 5.37703C4.89884 5.37703 5.01806 5.42642 5.10597 5.51433C5.19388 5.60223 5.24327 5.72146 5.24327 5.84578V11.5268C5.24327 11.6511 5.19388 11.7704 5.10597 11.8583C5.01806 11.9462 4.89884 11.9956 4.77452 11.9956C4.6502 11.9956 4.53097 11.9462 4.44306 11.8583C4.35515 11.7704 4.30577 11.6511 4.30577 11.5268Z"
            fill="#CC0000"
          />
        </g>
        <defs>
          <clipPath id="clip0_3103_67684">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
  <!-- <EditTask
    :dialog="editTaskDialog"
    @update:dialog="updateDialog"
    :id="item.id"
  /> -->
  <GeneralEdit
    v-model:dialog="dialog"
    :recordId="selectedId"
    :apiEndpoint="apiUrl"
    :fields="fields"
    :masterData="masterData"
    title="Edit Task"
    @submitted="afterSave"
  />
  <v-dialog v-model="deleteDialog" width="auto">
    <v-card max-width="550">
      <template v-slot:text>
        <div>
          <div class="d-flex justify-space-between align-center mb-8">
            <svg
              width="56"
              height="57"
              viewBox="0 0 56 57"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4"
                y="4.5"
                width="48"
                height="48"
                rx="24"
                fill="#FEE4E2"
              />
              <rect
                x="4"
                y="4.5"
                width="48"
                height="48"
                rx="24"
                stroke="#FEF3F2"
                stroke-width="8"
              />
              <path
                d="M32 22.5V21.7C32 20.5799 32 20.0198 31.782 19.592C31.5903 19.2157 31.2843 18.9097 30.908 18.718C30.4802 18.5 29.9201 18.5 28.8 18.5H27.2C26.0799 18.5 25.5198 18.5 25.092 18.718C24.7157 18.9097 24.4097 19.2157 24.218 19.592C24 20.0198 24 20.5799 24 21.7V22.5M26 28V33M30 28V33M19 22.5H37M35 22.5V33.7C35 35.3802 35 36.2202 34.673 36.862C34.3854 37.4265 33.9265 37.8854 33.362 38.173C32.7202 38.5 31.8802 38.5 30.2 38.5H25.8C24.1198 38.5 23.2798 38.5 22.638 38.173C22.0735 37.8854 21.6146 37.4265 21.327 36.862C21 36.2202 21 35.3802 21 33.7V22.5"
                stroke="#CC0000"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <svg
              @click="deleteDialog = false"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="cursor-pointer hoverd"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke="#717680"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div class="delete-dialog-body">
            <div class="main mb-2">
              Are you sure you want to delete this item
            </div>
            <div class="sub">
              If you deleted this item you won’t be able to restore it again
            </div>
          </div>
        </div>
      </template>
      <template v-slot:actions>
        <div class="pa-4 d-flex align-center ga-3">
          <v-btn
            class="cancel-btn"
            text="Cancel"
            @click="deleteDialog = false"
          ></v-btn>
          <v-btn
            class="delete-btn text-capitalize"
            color="white"
            text="Delete"
            @click="deleteTask"
          ></v-btn>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>
<script>
import EditTask from "@/components/crm/assets/forms/edit/EditTask.vue";
import apiClient from "@/core/buildRequest";
import { useTasksStore } from "@/store/crm/useTasksStore";
import { useGeneralStore } from "@/store/General";
import GeneralEdit from "@/components/crm/assets/forms/edit/GeneralEdit.vue";
export default {
  name: "PotentialityCol",
  props: ["item"],
  components: { EditTask, GeneralEdit },
  data() {
    return {
      editTaskDialog: false,
      deleteDialog: false,
      general_store: useGeneralStore(),
      apiUrl: "/leads-managment/tasks",
      dialog: false,
      masterData: {
        countries: [],
        cities: [],
        job_titles: [],
        accounts: [],
      },
      fields: [
        { model: "name", label: "Task Name", type: "text", required: true },
        {
          model: "description",
          label: "Description",
          type: "text",
          required: true,
        },

        {
          model: "add_to_calendar",
          label: "Add To Calendar",
          type: "switch",
          required: true,
          map: (d) => d.add_to_calendar == "1" || d.add_to_calendar === 1,
        },
        {
          model: "start_date",
          label: "Start Date",
          type: "date",
          required: true,
          map: (d) => (d.start_date ? d.start_date.substring(0, 10) : null),
        },
        // {
        //   model: "start_date",
        //   label: "Start Date",
        //   type: "date",
        //   required: true,
        // },
        // { model: "due_date", label: "Due Date", type: "date", required: true },
        // {
        //   model: "add_to_calendar_due",
        //   label: "Add Due Date To Calendar",
        //   type: "switch",
        //   required: true,
        // },
        {
          model: "due_date",
          label: "Due Date",
          type: "date",
          required: true,
          map: (d) => (d.due_date ? d.due_date.substring(0, 10) : null),
        },
        {
          model: "members_ids",
          label: "Assignees",
          type: "select",
          lazy: true,
          multiple: true,
          remoteEndpoint: "/leads-managment/all-agents",
          itemValue: "id",
          itemTitle: (item) =>
            `${item.first_name ?? ""} ${item.last_name ?? ""}`.trim(),
          map: (d) =>
            Array.isArray(d.members) ? d.members.map((m) => m.id) : [],
          required: true,
        },

        // {
        //   model: "contacts_ids",
        //   label: "Contacts",
        //   type: "select",
        //   lazy: true,
        //   multiple: true,
        //   remoteEndpoint: "/leads-managment/all-contacts",
        //   itemValue: "id",
        //   itemTitle: "contact_number",
        //   map: (d) =>
        //     Array.isArray(d.contacts) ? d.contacts.map((c) => c.id) : [],
        //   required: true,
        // },

        {
          model: "account_id",
          label: "Accounts",
          type: "select",
          lazy: true,
          remoteEndpoint: "/leads-managment/select-accounts",
          itemValue: "id",
          itemTitle: "account_number",
          map: (d) => d.account?.id || null,
          required: true,
        },

        {
          model: "status",
          label: "Status",
          type: "select",
          items: ["active", "pending", "on_hold", "completed", "closed"],
          required: true,
        },

        {
          model: "project_id",
          label: "Project",
          type: "select",
          lazy: true,
          remoteEndpoint: "/leads-managment/get-all-projects",
          itemValue: "id",
          itemTitle: "name",
          map: (d) => d.project?.id || null,
          required: true,
        },
        {
          model: "notes",
          label: "Notes",
          type: "text",
          required: true,
          map: (d) => d.notes || null,
        },
        {
          model: "attachment",
          label: "Attachment",
          type: "file",
          required: true,
        },

        // {
        //   model: "deal_id",
        //   label: "Deal",
        //   type: "select",
        //   lazy: true,
        //   remoteEndpoint: "/leads-managment/get-all-deals",
        //   itemValue: "id",
        //   itemTitle: "deal_number",
        //   map: (d) => d.deal?.id || null,
        //   required: true,
        // },

        // { model: "cost", label: "Cost", type: "text", required: true },
        // { model: "weight", label: "Weight", type: "text", required: true },
        // {
        //   model: "estimated_bonus",
        //   label: "Estimated Bonus",
        //   type: "text",
        //   required: true,
        // },
      ],
    };
  },
  methods: {
    updateDialog(value) {
      this.editTaskDialog = value;
    },
    openDialog(id) {
      this.selectedId = id;
      this.dialog = true;
    },
    afterSave() {
      const contact_store = useTasksStore();
      const general_store = useGeneralStore();
      contact_store.getAllTasks();
      general_store.showSnackbar("Contact updated successfully" , "#237276");
    },
    ShowDeleteTaskDialog() {},
    async deleteTask() {
      await apiClient
        .post(`/leads-managment/delete/tasks/${this.item.id}`)
        .then((res) => {
          const task_store = useTasksStore();
          task_store?.deleteTask(this.item);
          this.deleteDialog = false;
        });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style scoped>
.delete-dialog-body .main {
  font-size: 20px;
  font-weight: 600;
  line-height: 24.2px;
  color: #222222;
}
.delete-dialog-body .sub {
  font-size: 16px;
  font-weight: 400;
  line-height: 19.36px;
  color: #6a6a6a;
}
</style>
